/* Colourful Cottons hero card deck: a scattered pile of product cards. Flick the top card away to reveal
   the next one, tap it to open the product. Cards come from data-cc-deck JSON on the .cc-deck element. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function build(deck) {
    if (deck.dataset.ccReady) return;
    deck.dataset.ccReady = '1';
    var data; try { data = JSON.parse(deck.dataset.ccDeck || '[]'); } catch (e) { data = []; }
    if (!data.length) return;
    if (deck.dataset.shuffle === 'true') { for (var i = data.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = data[i]; data[i] = data[j]; data[j] = t; } }
    var SC = Math.max(0, Math.min(100, Number(deck.dataset.scatter || 60))) / 60;
    var hint = deck.querySelector('.cc-deck__hint');
    var wrap = deck.closest('.cc-deck-wrap') || deck.parentNode;
    var count = wrap.querySelector('[data-deck-count]');

    function scatter(c) { var m = (window.innerWidth < 700 ? .5 : 1) * SC; c._r = (Math.random() * 26 - 13) * SC; c._x = (Math.random() * 110 - 55) * m; c._y = (Math.random() * 50 - 25) * m; }
    var cards = data.map(function (p, i) {
      var a = document.createElement('a'); a.className = 'cc-pcard'; a.href = p.url; a.draggable = false;
      a.setAttribute('aria-label', p.title + ', ' + p.price);
      a.innerHTML = '<div class="cc-pcard__ph">' + (p.plus ? '<span class="cc-pcard__stamp">Plus sizes</span>' : '') +
        '<img src="' + p.img + '" alt="" draggable="false"' + (i > 2 ? ' loading="lazy"' : '') + '></div>' +
        '<div class="cc-pcard__band"><b>' + p.title + '</b><span><i>' + p.price + '</i>' + (p.sizes || '') + '</span></div>';
      scatter(a); deck.insertBefore(a, hint); return a;
    });
    var order = cards.slice(), history = [], seen = 1;
    function base(c, d) { return 'translate(-50%,-50%) translate3d(' + c._x + 'px,' + (c._y + d * 2) + 'px,' + (-d * 6) + 'px) rotate(' + c._r + 'deg)'; }
    function layout() {
      order.forEach(function (c, i) {
        c.style.zIndex = 100 - i; c.classList.toggle('is-top', i === 0);
        c.tabIndex = i === 0 ? 0 : -1; c.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
        if (!c.classList.contains('is-fly')) c.style.transform = i === 0 ? 'translate(-50%,-50%) translate3d(' + c._x * .3 + 'px,' + c._y * .3 + 'px,0) rotate(' + c._r * .35 + 'deg)' : base(c, i);
        c.style.opacity = i < 6 ? 1 : 0;
      });
      if (count) count.textContent = ((seen - 1) % order.length + 1) + ' of ' + order.length;
    }
    layout();

    function flyOff(c, vx, vy, spin) {
      var W = window.innerWidth, dir = vx === 0 ? 1 : Math.sign(vx);
      var tx = dir * (W * 0.75 + 300) + (c._dx || 0), ty = (c._dy || 0) + vy * 260 + (reduce ? 0 : 80);
      c.classList.remove('is-lift'); c.classList.add('is-fly');
      c.style.transform = 'translate(-50%,-50%) translate3d(' + tx + 'px,' + ty + 'px,0) rotate(' + (c._r + spin) + 'deg)'; c.style.opacity = reduce ? 0 : 1;
      history.push(c); order.shift(); order.push(c); seen++;
      setTimeout(function () {
        c.classList.remove('is-fly'); c.classList.add('is-under'); scatter(c);
        c.style.opacity = 0; layout(); requestAnimationFrame(function () { c.classList.remove('is-under'); });
      }, reduce ? 150 : 700);
      layout();
    }
    function next() { flyOff(order[0], 1, -0.2, 24); deck.classList.add('is-touched'); }
    function prev() {
      var c = history.pop(); if (!c) return;
      order.splice(order.indexOf(c), 1); order.unshift(c); seen = Math.max(1, seen - 1);
      c.classList.add('is-under'); c.style.transform = 'translate(-50%,-50%) translate3d(' + (-window.innerWidth) + 'px,-60px,0) rotate(-30deg)'; c.style.opacity = 1;
      requestAnimationFrame(function () { requestAnimationFrame(function () { c.classList.remove('is-under'); layout(); }); });
    }
    var nb = wrap.querySelector('[data-deck-next]'), pb = wrap.querySelector('[data-deck-prev]');
    if (nb) nb.addEventListener('click', next); if (pb) pb.addEventListener('click', prev);
    deck.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); next(); } if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); } });

    var drag = null;
    deck.addEventListener('pointerdown', function (e) {
      var c = e.target.closest('.cc-pcard'); if (!c || c !== order[0]) return;
      var r = c.getBoundingClientRect();
      drag = { c: c, id: e.pointerId, x0: e.clientX, y0: e.clientY, hist: [], moved: false, gy: (e.clientY - r.top) / r.height - .5 };
      c.setPointerCapture(e.pointerId); c.classList.add('is-lift'); c.style.transition = 'box-shadow .2s';
    });
    deck.addEventListener('pointermove', function (e) {
      var c = order[0];
      if (drag && e.pointerId === drag.id) {
        var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0, now = performance.now();
        if (Math.abs(dx) + Math.abs(dy) > 6) { drag.moved = true; deck.classList.add('is-touched'); }
        drag.hist.push([now, e.clientX, e.clientY]); if (drag.hist.length > 6) drag.hist.shift();
        var rot = c._r * .35 + dx * 0.08 * (drag.gy < 0 ? 1 : -1); // pivots around where you hold it, like a real card
        var tiltY = Math.max(-14, Math.min(14, dx * 0.05)), tiltX = Math.max(-10, Math.min(10, -dy * 0.05));
        c._dx = dx; c._dy = dy;
        c.style.transform = 'translate(-50%,-50%) translate3d(' + dx + 'px,' + dy + 'px,40px) rotate(' + rot + 'deg) rotateY(' + tiltY + 'deg) rotateX(' + tiltX + 'deg) scale(1.03)';
        c.style.setProperty('--gx', (50 + tiltY * 3) + '%'); c.style.setProperty('--gy', (30 - tiltX * 3) + '%'); c.style.setProperty('--gloss', .9);
        return;
      }
      if (!fine || reduce || !c) return;
      var r = c.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { reset(c); return; }
      var px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
      c.style.transition = 'transform .12s ease-out,box-shadow .35s';
      c.style.transform = 'translate(-50%,-50%) translate3d(' + c._x * .3 + 'px,' + (c._y * .3 - 6) + 'px,30px) rotate(' + c._r * .35 + 'deg) rotateY(' + (px * 14) + 'deg) rotateX(' + (-py * 12) + 'deg)';
      c.style.setProperty('--gx', (px + .5) * 100 + '%'); c.style.setProperty('--gy', (py + .5) * 100 + '%'); c.style.setProperty('--gloss', .85);
    });
    function reset(c) { c.style.transition = ''; c.style.setProperty('--gloss', 0); layout(); }
    deck.addEventListener('pointerleave', function () { if (!drag && order[0]) reset(order[0]); });
    function end(e) {
      if (!drag || e.pointerId !== drag.id) return; var c = drag.c, h = drag.hist; c.style.transition = ''; c.classList.remove('is-lift'); c.style.setProperty('--gloss', 0);
      if (!drag.moved) { drag = null; layout(); return; }
      var vx = 0, vy = 0; if (h.length > 1) { var a = h[0], b = h[h.length - 1], dt = Math.max(16, b[0] - a[0]); vx = (b[1] - a[1]) / dt; vy = (b[2] - a[2]) / dt; }
      var far = Math.abs(c._dx) > c.offsetWidth * .42;
      if (Math.abs(vx) > .45 || far) { flyOff(c, vx || c._dx, vy, (vx || c._dx) > 0 ? 28 : -28); } else { c._dx = c._dy = 0; layout(); }
      drag.suppress = true; var dd = drag; setTimeout(function () { if (drag === dd) drag = null; }, 0);
    }
    deck.addEventListener('pointerup', end); deck.addEventListener('pointercancel', end);
    deck.addEventListener('click', function (e) { var c = e.target.closest('.cc-pcard'); if (!c) return; if (c !== order[0] || (drag && drag.suppress) || c.classList.contains('is-fly')) { e.preventDefault(); drag = null; } }, true);
  }

  function init(root) { (root || document).querySelectorAll('.cc-deck').forEach(build); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
